import { createContext, useContext } from "react";

export interface LeftPanelRect {
  right: number;
  top: number;
}

export const LeftPanelContext = createContext<LeftPanelRect | null>(null);
export const useLeftPanelRect = () => useContext(LeftPanelContext);
